<template>
  <div class="full-image mt-2">
    <div v-if="status == 'ready' || status == 'png_ready'">
      <a href="#" class="btn btn-primary" v-on:click="download" v-if="target == 'download'">
        Download
      </a>
      <div v-if="target == 'download_or_edit'" class="btn-group">
        <button type="button" class="btn btn-primary " @click="download">
          Download
        </button>
        <button type="button" class="btn btn-primary dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"  style="background: #0587f6; padding: 0 10px;">
          <span class="sr-only">Toggle dropdown</span>
        </button>
        <div class="dropdown-menu dropdown-menu-right py-1">
          <a class="dropdown-item" href="#" @click.prevent="edit">Edit</a>
        </div>
      </div>
      <div v-if="target == 'edit_or_download'" class="btn-group">
        <button type="button" class="btn btn-primary " @click="edit">
          Edit
        </button>
        <button type="button" class="btn btn-primary dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"  style="background: #0587f6; padding: 0 10px;">
          <span class="sr-only">Toggle dropdown</span>
        </button>
        <div class="dropdown-menu dropdown-menu-right py-1">
          <a class="dropdown-item" href="#" @click.prevent="download">Download</a>
        </div>
      </div>
    </div>
    <div v-if="status == 'processing' || status == 'zip_ready'">
      <div class="small">
        {{ statusMessage }}
      </div>
      <div class="progress" style="margin-bottom: 0;">
        <div class="progress-bar" role="progressbar" v-bind:style="{width: `${progressPercent}%`}">

        </div>
      </div>
    </div>
    <div v-if="status == 'error'" class="alert alert-danger">
      {{ statusMessage }}
    </div>
    <div v-if="note" class="text-muted mt-1" style="font-size: 80%; line-height: 1.4;">
      {{ note }}
    </div>
  </div>
</template>

<script>
import {ZipCanvas} from '@remove-bg/remove-bg-tools';

import EditorUI from '../src/editor/editor_ui';
import blobToBase64 from '../src/blob_to_base64';

export default {
  props: {
    id: String,
    url: String,
    initialNote: String,
    basename: String,
    originalUrl: String,
    foregroundType: String,
    isTemplate: Boolean,
    downloadCallback: Function,
    target: String,
  },
  data() {
    return {
      status: "ready",
      statusMessage: "",
      progressPercent: 0,
      zipUrl: "",
      requestedAction: null,
      zipCanvas: null,
      note: this.initialNote,
    };
  },
  methods: {
    download(e) {
      e.preventDefault();
      if(this.status == "png_ready") {
        this.downloadNow();
      }

      if(this.status == "ready") {
        this.requestedAction = "download";
        this.startProcessing();
      }
    },
    edit(e) {
      e.preventDefault();
      if(this.status == "png_ready") {
        this.editNow();
      }

      if(this.status == "ready") {
        this.requestedAction = "edit";
        this.startProcessing();
      }
    },
    startProcessing() {
      this.status = "processing";
      this.statusMessage = "Processing…";
      this.progressPercent = 10;
      this.fetchResult();
    },
    fetchResult() {
      $.ajax({
        type: 'POST',
        url: `${this.url}/full_image.json`,
        dataType: 'json',
        success: (data) => {
          this.statusUpdated(data);
        },
        error: (e) => {
          console.log(e);
          this.failed("Download request failed - please try again.");
        }
      })
    },
    statusUpdated(data) {
      switch(data.status) {
      case "error":
        this.failed("Processing failed - please try again.");
        return;
      case "processing":
        if(data.percent_estimate) {
          this.progressPercent = 10 + data.percent_estimate * 0.5;
        }
        setTimeout(() => {
          this.fetchResult();
        }, data.fetch_in);
        return;
      case "zip_ready":
        this.progressPercent = 60;
        this.status = "zip_ready";
        if(data.note) this.note = data.note;
        this.fetchDownloadUrl();
        return;
      }
    },
    fetchDownloadUrl() {
      this.statusMessage = "Downloading…"
      this.progressPercent = 65;
      $.ajax({
        type: 'GET',
        url: `${this.url}/full_image/download.json`,
        dataType: 'json',
        success: (data) => {
          if(data && data.data && data.data.url) {
            this.zipUrl = data.data.url;
            this.convertZipToPng();
          }
          else {
            this.failed("Failed to fetch download url - please try again.");
          }
        },
        error: (e) => {
          this.failed("Failed to fetch download url - please try again.");
        }
      })
    },
    convertZipToPng() {
      this.progressPercent = 70;
      this.statusMessage = "Saving…"
      ZipCanvas.fromUrl(this.zipUrl, {mimeType: "image/png"}, (progress) => {
        if(progress.stage == "download") {
          this.statusMessage = "Downloading…"
        }
        else {
          this.statusMessage = "Saving…"
        }
        this.progressPercent = 70 + progress.percent * 0.3;
      }).then((zipCanvas) => {
        this.zipCanvas = zipCanvas;
        this.status = "png_ready";
        this.handleRequestedAction();
      }).catch(err => {
        if(err.name == "InvalidStateError") {
          // Regression in Safari 15 https://bugs.webkit.org/show_bug.cgi?id=230855
          this.failed("Download failed. If you are using Safari please try to download this image with Google Chrome or Firefox.");
        } else {
          this.failed("Failed to fetch download url - please try again.");
        }
      });
    },
    handleRequestedAction() {
      if(this.requestedAction == "download") return this.downloadNow();
      if(this.requestedAction == "edit") return this.editNow();
    },
    downloadNow() {
      if(this.isTemplate) {
        this.statusMessage = "Downloading…"

        var url = this.zipCanvas.createURL();
        this.downloadCallback(url);
      }
      else {
        var filename = this.basename + "-removebg.png";
        if(window.mobile_app) {
          var b64_regexp = /^data:image\/png;base64,/;
          if(this.zipCanvas.dataUrl) {
            window.mobile_app.downloadBase64(filename, this.zipCanvas.dataUrl.replace(b64_regexp, ''));
          }
          else if(this.zipCanvas.blob) {
            blobToBase64(this.zipCanvas.blob).then((base64) => {
              window.mobile_app.downloadBase64(filename, base64.replace(b64_regexp, ''));
            });
          }
        }
        else {
          this.zipCanvas.download(filename);
        }
      }
    },
    editNow() {
      var url = this.zipCanvas.createURL();

      // TODO: for clean up do at some point
      // this.zipCanvas.revokeURL(url);

      EditorUI.show({
        "foreground-url": url,
        "original-url": this.originalUrl,
        "filename": this.basename + "-removebg.png",
        "foreground-type": this.foregroundType,
        "locale": document.documentElement.lang
      });
    },
    failed(message) {
      this.status = "error";
      this.statusMessage = message;
    }
  }
}
</script>

<style scoped>

</style>
